import bluetech from '../img/bluetech.jpg'
import wago from '../img/wago-750-8212.jpg'
import bluetechibt from '../img/bluetechibt.jpg'
import pe200u from '../img/pe200u.png'
import sdc from '../img/EL-20-3050-32.png'

const products = [
    {
      company: 'Empresa 1',
      image: wago,
      titleImage: "PFC200 750-8212",
      titleItem: "Controlador WAGO 750-8212",
      licenca: 1,
      tipo: "PiD",
      expirate: "2021/09/21",
      hardware: "PFC200",
    },
    {
      company:'Empresa 1',
      image: bluetechibt,
      titleImage: "BlueTech IBT 1800",
      titleItem: "MiniPC Bluetech IBT 1800",
      licenca: 2,
      tipo: "PiD",
      expirate: "2021/11/21",
      hardware: "Bwise IBT 1800",
    },
    {
      company:'Empresa 3',
      image: sdc,
      titleImage: "EL-20-3050-32",
      titleItem: "EL-20-3050-32",
      licenca: '40xxxxx-xxxxxxx-xxx',
      tipo: "Historian",
      expirate: "2021/01/21",
      hardware: "EL-20-3050-32",
    },
    {
      company:'Empresa 4',
      image: bluetech,
      titleImage: "BlueTech IBT 1800",
      titleItem: "MiniPC Bluetech IBT 1800",
      licenca: '42xxxxx-xxxxxxx-xxx',
      tipo: "Historian",
      expirate: "2021/11/26",
      hardware: "Bwise IBT 1800",
    },
    {
      company:'Empresa 5',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '42xxxx34x-xxxxxxx-xxx',
      tipo: "Historian",
      expirate: "2022/12/22",
      hardware: "PE200U",
    },
    {
      company:'Empresa 5',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '412312xxx-xxxxxxx-xxx',
      tipo: "Historian",
      expirate: "2021/12/22",
      hardware: "PE200U",
    },
    {
      company:'Empresa 7',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: 7,
      tipo: "Historian",
      expirate: "2021/12/22",
      hardware: "PE200U",
    },
    {
      company:'Empresa 6',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: 8,
      tipo: "Historian",
      expirate: "2021/12/22",
      hardware: "PE200U",
    },
    {
      company:'Empresa 6',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: 9,
      tipo: "Historian",
      expirate: "2021/12/22",
      hardware: "PE200U",
    },
    {
      company:'Empresa 5',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: 10,
      tipo: "Historian",
      expirate: "2021/12/22",
      hardware: "PE200U",
    },
    {
      company:'Empresa 8',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: 11,
      tipo: "Historian",
      expirate: "2021/10/22",
      hardware: "PE200U",
    },
    {
      company:'Empresa 8',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: 11,
      tipo: "Historian",
      expirate: "2021/10/22",
      hardware: "PE200U",
    },
    {
      company:'Empresa 11',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: 11,
      tipo: "Historian",
      expirate: "2021/10/22",
      hardware: "PE200U",
    },
  ]
  export default products